import axios from '@/config/httpConfig'
// 报表文件夹新增页信息
export function getNewReportFolder() {
    return axios.post('/report/getNewReportFolder')
}